import * as React from 'react';
import { ISearchResultHitDTO } from '../../DTO/search';

interface IProps {
    result: ISearchResultHitDTO;
    onClick: (hitId: string) => void;
}

export function Result({ result, onClick }: IProps) {
    const renderCategory = (category: string, index: number) => {
        return (<span key={category + '-' + index} className="adage-search-results-item-category">{category}</span>);
    };

    const hitOnClick = () => onClick(result.hitId);

    return (
        <li className={"adage-search-results-item " + (result.isBestBet ? "best-bet" : "")}>
            <h2>
                <a className="adage-search-results-item-link" href={result.url} onClick={hitOnClick} dangerouslySetInnerHTML={{ __html: result.title }}>                    
                </a>
            </h2>
            {result.description &&
            <p className="adage-search-results-item-desc">{result.description}</p>
            }
            {result.categories &&
                <div className="adage-search-results-item-categories">
                    {result.categories ? result.categories.map((x, index) => renderCategory(x, index)) : null}
                </div>
            }
        </li>
    );
};
